import { render } from "./BlFormSubmit.vue?vue&type=template&id=2c593e2e"
import script from "./BlFormSubmit.vue?vue&type=script&lang=js"
export * from "./BlFormSubmit.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__